import { gql } from "@apollo/client/core";
import {
  GetWindowConfigQueryResponse,
  WindowConfig,
} from "../../../../../graphql/types/config";

type FetchWindowConfigApiResponse = {
  windowConfig: WindowConfig;
};

export type GetWindowConfigOperationResponse =
  GetWindowConfigQueryResponse<FetchWindowConfigApiResponse>;

export const GET_WINDOW_CONFIG = gql`
  query GetWindowConfig {
    getWindowConfig {
      windowConfig {
        taskNameLimit
        taskDescriptionLimit
        activityCategoryFilters
      }
    }
  }
`;
